export default __webpack_public_path__ + "static/2185-f43610b615f24859c4d56da10148ad8d.jpeg";